<template>
    <section>
        <div>
            <h1>Events and Activities</h1>
        </div>
        <div>
            <p>
                Nino to assess with DCO and other IBC members whether enough good material/info could be made available to us and in that case add a list of main events from April to December.
            </p>
        </div>
        <v-row>
            <v-col v-for="card in cards" :key="card.id" cols="12" md="3">
                <v-card class="mx-auto" max-width="380" min-height="180" @mouseenter="flipCard(card.id, true)" @mouseleave="flipCard(card.id, false)">
                    <!-- Cara frontal del card con la imagen y el título -->
                    <div v-if="cardState[card.id] && !cardState[card.id].isFlipped">
                        <v-carousel :show-arrows="false" cycle height="180" hide-delimiters>
                            <v-carousel-item v-for="(image, index) in card.images" :key="index">
                                <!-- Ajusta el estilo de v-img para cubrir el espacio del v-card -->
                                <v-img class="align-end text-white" height="100%" :src="getImageSrc(image)" :style="{ 'object-fit': 'cover' }">
                                    <!-- Aplica el color blanco al título del v-card -->
                                    <v-card-title style="color: white; font-size: 16px;">{{ card.title }}</v-card-title>
                                    <v-divider class="mx-2 mb-1"></v-divider>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                    </div>

                    <!-- Cara posterior del card con el título, la descripción y los botones -->
                    <div v-else :style="{ 'background-color': 'rgb(15, 135, 201)' }">
                        <v-divider class="mx-2 mb-1"></v-divider>
                        <v-card-title>{{ card.title }}</v-card-title>
                        <v-card-subtitle><b>{{ card.description }}</b></v-card-subtitle>
                        <v-divider class="mx-4 mb-1"></v-divider>
                        <!--<v-card-text>
                            <div><b>Description</b></div>
                            <div>{{ card.description }}</div>
                            <br>
                            <div>{{ card.additionalInfo }}</div>
                        </v-card-text>-->
                        <v-card-actions>
                            <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }" :href="card.link" target="_blank"> Link </v-btn>
                            <v-spacer></v-spacer>
                            <router-link :to="{ name: 'publication', params: { id: card.id } }">
                                <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Details </v-btn>
                            </router-link>
                        </v-card-actions>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </section>
</template>

<script>
import NoticiaDetalle from './NoticiaDetalle.vue';
import Publication from './Publication.vue';
import axios from 'axios';

export default {
    components: {
        NoticiaDetalle,
        Publication,
    },
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: '',
                r_images: '',
                link: '',
                folder: '',
            },
            cards: [
                {
                    id: 1,
                    title: 'Corruption',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['category1-1.jpg'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
                {
                    id: 2,
                    title: 'Crime prevention and criminal justice',
                    subtitle: 'INEGI',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2Additional Info for Card 2Additional Info for CAdditional Info for Card 2Additional Info for Card 2Additional IAdditional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2nfo for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2ard 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2',
                    images: ['Category2-1.jpg'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 3,
                    title: 'Cybercrime',
                    subtitle: 'UNESCO',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 3',
                    images: ['Category3-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/UNESCO%20rule%20of%20law%20through%20education?csf=1&web=1&e=3Dt35A',
                },
                {
                    id: 4,
                    title: 'Drugs',
                    subtitle: 'UNICEF',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['Category4-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 5,
                    title: 'Environmental crimes',
                    subtitle: 'Bolivia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 5',
                    images: ['Category5-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 6,
                    title: 'Firearms',
                    subtitle: 'Brazil',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 6',
                    images: ['Category6-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 7,
                    title: 'Gender-based violence',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category7-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },                
                {
                    id: 8,
                    title: 'Human trafficking and migrant smuggling',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category8-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 9,
                    title: 'Money laundering',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category9-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 10,
                    title: 'Organized crime',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category10-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 11,
                    title: 'Prison and penal reform',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category11-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 12,
                    title: 'Terrorism prevention',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category12-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 13,
                    title: 'Violence against children',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category13-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 14,
                    title: 'Violent crimes/homicides',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category14-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 15,
                    title: 'Citizen Security',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category15-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
            ],
            cardState: {},
        };  
    },
    mounted() {
      this.listar();
    },
    methods: {
        // Obtener la lista de Categiries
        async listar() {
            try {
                const response = await axios.get('api/Categories/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        additionalInfo: category.additionalInfo,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                        link: category.link,
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        flipCard(cardId, isFlipped) {
            // Verificar si cardState[cardId] existe antes de acceder a sus propiedades
            if (this.cardState[cardId]) {
                this.$set(this.cardState[cardId], 'isFlipped', isFlipped);
            } else {
                // Si no existe, inicialízalo con isFlipped
                this.$set(this.cardState, cardId, { isFlipped });
            }
        },
    },
    created() {
        // Initialize cardState for each card
        this.cards.forEach(card => {
            this.$set(this.cardState, card.id, { isFlipped: false });
        });
    },
    
};
</script>
<style>
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
</style>